<template>
  <a :href="href" class="info-card--a"
    ><div ref="card" class="info-card" @mouseenter="enter" @mouseleave="leave">
      <div class="info-card--bg"><img :src="item.src" alt="" /></div>
      <div ref="pos" class="ab-positioned">
        <div class="info-card--desc">
          <div class="info-card--type">
            <div ref="btnText">{{ item.cate }}</div>
          </div>
          <div class="info-card--content">
            <h3 class="info-card--title">{{ item.title || 'Lorem' }}</h3>
          </div>
        </div>
        <div ref="text" class="info-card--text text-ellipsis">
          <p>{{ item.p }}</p>
        </div>
      </div>
    </div></a
  >
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    },
    href: {
      type: String,
      default: '#'
    }
  },
  created() {
    this.item.cate = this.item.cate || '作品'
  },
  methods: {
    enter() {
      const height = this.$refs.text.offsetHeight
      this.$refs.btnText.innerHTML = 'Read More'
      this.$refs.card.style.setProperty('--transformY', `-${height}px`)
    },
    leave() {
      this.$refs.btnText.innerHTML = this.item.cate
      this.$refs.card.style.setProperty('--transformY', `0`)
    }
  }
}
</script>

<style lang="scss" scoped>
.info-card--a {
  display: block;
  // height: 300px;
  min-height: 300px;
  $content-padding-x: 20px;
  $content-padding-y: 30px;
  $content-padding-bottom: 20px;
  $cate-color: black;
  $text-color: white;
  $background: rgba(0, 0, 0, 0.7);
  --transformY: 0;
  .info-card {
    cursor: pointer;
    overflow: hidden;
    // background: #ffa773;
    flex-shrink: 1;
    height: 100%;

    position: relative;
    %card-btn {
      margin: 0;
      color: $cate-color;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 12px;
      line-height: 1.5;
      box-sizing: border-box;
      white-space: nowrap;
    }
    %card-btn-inner {
      background: #fff;
      padding: 0.5em 1.2em;
    }
    * {
      margin: 0;
      padding: 0;
    }

    .info-card--bg {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      z-index: -1;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease-out;
      }
    }
    .info-card--type,
    .info-card--title {
      text-transform: uppercase;
    }
    .ab-positioned {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      transition: transform 0.5s ease-out;
      transform: translateY(var(--transformY));
    }
    .info-card--desc {
      background: $background;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: $content-padding-y $content-padding-x #{$content-padding-y - 10px};
      .info-card--type {
        @extend %card-btn;
        > div {
          @extend %card-btn-inner;
        }
      }
      .info-card--content {
        font-size: 14px;
        color: $text-color;
        text-align: center;
      }
    }
    .info-card--text {
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      background: $background;
      padding: 0 $content-padding-x $content-padding-bottom;
      color: $text-color;
      p {
        $line-height: 1.2;
        line-height: $line-height;
        height: 3 * $line-height;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
    &:hover {
      .info-card--bg {
        img {
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>
